import { createFileRoute } from "@tanstack/react-router";

import { useT } from "../../../app/i18n";
import { nextSearch } from "../../../features/auth/next";
import { OtpForm } from "../../../features/auth/otp-form";

export const Route = createFileRoute("/_auth/sign-in/otp")({
  validateSearch: nextSearch,
  component: OtpPage,
});

function OtpPage() {
  const { t } = useT();
  const { next } = Route.useSearch();
  return (
    <>
      <h1 className="mb-6 text-xl font-semibold">{t("auth:otp.title")}</h1>
      <OtpForm next={next} />
    </>
  );
}
